import { useTheme } from './hooks/useTheme'
import { useKeyboardShortcuts } from './hooks/useKeyboardShortcuts'
import { useUIStore } from './stores/uiStore'
import Sidebar from './components/Sidebar/Sidebar'
import Toolbar from './components/Editor/Toolbar'
import CodeEditor from './components/Editor/CodeEditor'
import MarkdownPreview from './components/Preview/MarkdownPreview'
import StatusBar from './components/Editor/StatusBar'
import ThemeToggle from './components/common/ThemeToggle'

export default function App() {
  useTheme()
  useKeyboardShortcuts()

  const viewMode = useUIStore((s) => s.viewMode)

  return (
    <div className="flex flex-col h-screen bg-editor-bg text-editor-fg">
      <header className="flex items-center justify-between px-3 py-1.5 border-b border-editor-border bg-editor-toolbar shrink-0">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-sm">Markdown Editor</span>
        </div>
        <ThemeToggle />
      </header>

      <div className="flex flex-1 overflow-hidden">
        <Sidebar />

        <main className="flex flex-col flex-1 overflow-hidden">
          <Toolbar />

          <div className="flex flex-1 overflow-hidden">
            {(viewMode === 'editor' || viewMode === 'split') && (
              <div
                className={`overflow-hidden ${
                  viewMode === 'split' ? 'w-1/2 border-r border-editor-border' : 'flex-1'
                }`}
              >
                <CodeEditor />
              </div>
            )}

            {(viewMode === 'preview' || viewMode === 'split') && (
              <div
                className={`overflow-hidden bg-editor-bg ${
                  viewMode === 'split' ? 'w-1/2' : 'flex-1'
                }`}
              >
                <MarkdownPreview />
              </div>
            )}
          </div>

          <StatusBar />
        </main>
      </div>
    </div>
  )
}
